import * as React from 'react'

const SvgTwitterIcon = (props) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1_107287)">
      <path
        d="M8.04752 21.7508C17.1042 21.7508 22.0578 14.2474 22.0578 7.74052C22.0578 7.5274 22.0578 7.31524 22.0434 7.10404C23.007 6.407 23.8389 5.54392 24.5 4.55524C23.6014 4.95364 22.648 5.2148 21.6718 5.32996C22.6998 4.71465 23.4692 3.74674 23.8366 2.60644C22.8701 3.18005 21.8126 3.58427 20.7099 3.80164C19.9675 3.01222 18.9856 2.48948 17.9162 2.31432C16.8468 2.13917 15.7494 2.32135 14.794 2.83269C13.8385 3.34403 13.0782 4.15601 12.6307 5.14299C12.1833 6.12996 12.0735 7.23691 12.3186 8.29252C10.3609 8.19432 8.44576 7.68555 6.69745 6.79924C4.94915 5.91294 3.40676 4.6689 2.1704 3.14788C1.54073 4.23188 1.34787 5.51511 1.6311 6.7363C1.91433 7.9575 2.65234 9.02483 3.69488 9.721C2.91123 9.69804 2.14465 9.48663 1.46 9.10468V9.16708C1.46031 10.3039 1.85385 11.4057 2.57387 12.2854C3.29389 13.1652 4.29606 13.7689 5.4104 13.994C4.68548 14.1917 3.92487 14.2206 3.18704 14.0784C3.50181 15.0568 4.11443 15.9123 4.93924 16.5254C5.76405 17.1385 6.75983 17.4785 7.78736 17.498C6.76644 18.3004 5.59731 18.8938 4.34687 19.244C3.09643 19.5942 1.78921 19.6944 0.5 19.5389C2.75183 20.9839 5.37192 21.7504 8.04752 21.7469"
        fill="#1DA1F2"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_107287">
        <rect width="24" height="24" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgTwitterIcon
